import React, { useState } from "react";
import Iframe from "react-iframe";
import { InlineMath } from "react-katex";
const Cb1 = () => {
	const [show, setShow] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);
	const [form1, setForm1] = useState({
		width: "50px",
		height: "30px",
		textAlign: "center",
	});
	const [form2, setForm2] = useState({
		width: "50px",
		height: "30px",
		textAlign: "center",
	});
	const [form3, setForm3] = useState({
		width: "50px",
		height: "30px",
		textAlign: "center",
	});
	const [form4, setForm4] = useState({
		width: "50px",
		height: "30px",
		textAlign: "center",
	});
	const handleform1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "8") {
			setShow2(true);
			setForm1({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm1({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm1({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "6") {
			setShow(true);
			setForm2({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm2({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm2({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "8,0") {
			setShow3(true);
			setForm3({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm3({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm3({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	const handleform4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0,6") {
			setShow4(true);
			setForm4({
				border: "6px solid #1aff66",
				width: "50px",
				height: "30px",
			});
		} else if (jwb === "") {
			setForm4({
				border: "6px solid yellow",
				width: "50px",
				height: "30px",
			});
		} else {
			setForm4({
				border: "6px solid red",
				width: "50px",
				height: "30px",
			});
		}
	};
	return (
		<div className="container mt-2">
			<div className="text-center">Ditentukan pertidaksamaan berikut</div>
			<div className="text-center">
				<InlineMath math="3x + 4y ≤ 24" />
			</div>
			<ul style={{ width: "80%", margin: "auto" }}>
				
				<p className="text-center alert alert-warning h6">Lengkapi form di bawah ini dengan titik potong pada sumbu <InlineMath math=" x "/> dan titik potong pada sumbu <InlineMath math=" y "/></p>
				<div className="text-center">
				<InlineMath math="3x + 4y = 24" />
			</div>
				<div className="d-flex justify-content-center">
					<table
						style={{
							border: "2px solid green",
							borderCollapse: "collapse",
							width: "30%",
							textAlign: "center",
							marginBottom: "1rem",
						}}
					>
						<tr>
							<th
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
								}}
							>
								<i>x</i>
							</th>
							<th
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
								}}
							>
								<input style={form1} onChange={handleform1} type="text" />
							</th>
							<th
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
								}}
							>
								<i>0</i>
							</th>
						</tr>
						<tr>
							<td
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
								}}
							>
								<i>y</i>
							</td>
							<td
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
								}}
							>
								<i>0</i>
							</td>
							<td
								style={{
									border: "2px solid green",
									borderCollapse: "collapse",
								}}
							>
								<input style={form2} onChange={handleform2} type="text" />
							</td>
						</tr>
					</table>
				</div>
				{show&&show2 ? (
					<>
					<div className="d-flex justify-content-center">
						<p>Maka titik koordinat A = (<input type="text"  style={form3} onChange={handleform3}  />)</p> 
						</div>
					<div className="d-flex justify-content-center">
						<p>Maka titik koordinat B = (<input type="text"  style={form4} onChange={handleform4}  />)</p> 
						</div>
				{show3&&show4?
				<>
				<div className="text-center alert alert-warning h6">Kerjakan grafik di bawah ini</div>
						<div className="d-flex justify-content-center">
							<Iframe
 scrolling="no" title="Cb1mm" src="https://www.geogebra.org/material/iframe/id/jqdtzjxf/width/800/height/550/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/false/sdz/false/ctl/false" width="800px" height="550px"	allowFullScreen	/>
					
						</div>
				</>
				:null}		
					</>
				) : null}
			</ul>
		</div>
	);
};

export default Cb1;
